import { render, staticRenderFns } from "./VModalAttachFiles.vue?vue&type=template&id=e4fc8532&"
import script from "./VModalAttachFiles.vue?vue&type=script&lang=ts&"
export * from "./VModalAttachFiles.vue?vue&type=script&lang=ts&"
import style0 from "./VModalAttachFiles.vue?vue&type=style&index=0&id=e4fc8532&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports